/**
 * @author chaixianguo
 * @date 2025-08-15
 */
<template>
  <section class="about-box" id="about">
    <!-- <h2>关于我们</h2> -->
    <img v-lazy="item" v-for="(item,index) in imglist" :key="index" alt="">
  </section>
</template>

<script>
 import request from '@/utils/request'
export default {
  name: 'aboutBox',
  components: {},
  props: {},
  data() {
    return {
      imglist: [] 
    };
  },
  methods: {
    async getList() {
      try {
        const response = await request({
          url: '/advertisement/getListByPosition',
          method: 'get',
          params: { adPosition: 'AboutusBackgroud' } // URL 参数
        })
        this.imglist = response.data
      } catch (error) {
        console.error('获取列表失败:', error)
      }
    },
  },
  mounted() {
     this.getList()
  }
}
</script>

<style>
  .about-box{
    box-sizing: border-box;
    min-width: 1000px;
    width: 70vw;
    min-height: calc(100vh - 100px);
    background: #FFF;
    border-radius: 10px;
    padding:20px;
    margin-top: 10px;
  }
  .about-box img{
    width: 100%;
  }
</style>